import { BrowserRouter, Navigate, Route, Routes, useLocation } from "react-router-dom";
import { navBar, getInTouch } from "./editable-stuff/config.js";
import Footer from "./components/Footer";
import SiteNav from "./components/SiteNav";
import GetInTouch from "./components/home/GetInTouch.jsx";
import { NotesSheet } from "./components/home/Notes";
import CurriculumVitae from "./components/home/CurriculumVitae";
import ProjectsList from "./components/home/ProjectsList";
import Plate from "./components/plate/Plate";
import ReadableSheet from "./components/plate/ReadableSheet";

// The old site's front page (/projects: MainBody, AboutMe, Projects,
// AgentQuoteWall, Interests) is retired. Liz, 2026-10-11: "retire it for now."
// The components are still in the repo, just unrouted, so putting any of them
// back is a route away. Its unique content - About Me, Things I'm Following
// and the Agent Quote Wall - currently has no home on the live site.

// Sheets carry their own furniture: the plate ("/") is a full-viewport drawing
// with its own sheet references, and the CV (C-1) and Notes (N-1) each draw
// their own title block. The dark "Come build with me" footer stays off every
// sheet. It belongs to the old site's pages (/projects, /work), where the
// contact path lives.
const SHEET_PATHS = ["/", "/cv", "/notes", "/work", "/readable"];
export const AppRoutes = () => {
  const { pathname } = useLocation();
  const onPlate = pathname === "/";
  const onSheet = SHEET_PATHS.includes(pathname);

  return (
    <>
      {navBar.show && !onPlate && <SiteNav />}
      <Routes>
        <Route path="/" element={<Plate />} />
        {/* The drawing as text: the canvas cannot be read, so this is the
            route the accessible entry link points at. Generated from the same
            decomposition data, so it cannot drift from the map. */}
        <Route path="/readable" element={<ReadableSheet />} />
        {/* /projects was the old site and is retired. It is kept as a redirect
            and not deleted: it is the address the readable-version link used
            to carry, so anyone holding that link still lands somewhere real. */}
        <Route path="/projects" element={<Navigate to="/readable" replace />} />
        <Route path="/work" element={<ProjectsList />} />
        <Route path="/notes" element={<NotesSheet />} />
        <Route path="/cv" element={<CurriculumVitae />} />
      </Routes>
      {!onSheet && (
        <Footer>
          {getInTouch.show && (
            <GetInTouch
              heading={getInTouch.heading}
              message={getInTouch.message}
              email={getInTouch.email}
            />
          )}
        </Footer>
      )}
    </>
  );
};

const App = () => (
  <BrowserRouter basename={process.env.PUBLIC_URL + "/"}>
    <AppRoutes />
  </BrowserRouter>
);

export default App;
